import { Slide } from "@jelly/lesson";
import theory from "../../theory";
import config from "appConfig";

const principle: Slide = {
  descriptionHtml: `This animation displays the Fourier transform of a rectangular signal (displayed on top) which depends on
  <ul>
  <li>its amplitude
  <li>its lower and higher time bounds a and b
  </ul>
  You can modify these parameters and observe the evolution of the Fourier transform. In particular you can observe that:
  <ul>
  <li>When you modify the amplitude of the original signal, the Fourier transform is just multiplied by the corresponding factor.
  <li>When you shift the signal in time, the modulus is unchanged (it is associated to a change in the phase of the signal)
  <li>When the signal is short, the Fourier transform becomes flat
  <li>When the signal is long, its Fourier transform tends to a peak
  </ul>`,
  theory: theory,
  collapsibleDescription: true,
  collapsedDescriptionTextLines: 3,
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "blockContainer",
        data: {
          block: {
            type: "iframe",
            options: {
              src: `${config.IFRAMES_REACT_URL}/0304/`,
            },
          },
        },
      },
    },
  },
};

export default principle;
